import Spinner from './Spinner'
export * from './MobileSpinner'

export default Spinner
